export const LANGUAGE = {
  ENG: 'eng',
  THA: 'tha',
}

export const mappingLanguage = {
  [LANGUAGE.ENG]: 'en',
  [LANGUAGE.THA]: 'th',
}
